import React, { useState } from "react";
import CoursesData from "../content.json";
import { BsLightningFill } from "react-icons/bs";
import { Helmet } from "react-helmet";


import Courses from "../Components/Courses"

function MEd() {

  // document.getElementsByClassName("CourseContainer").style.marginTop="0";
  const [MCAData] = useState(CoursesData.Courses[1]);
  return (
		<>
			<Helmet>
				<title>M.Ed. | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="">
					{/* <div className="CourseBanner HeaderImg">
						<img src={MCAData.course_banner} alt="MCA-banner" />
					</div> */}

					<div id="Heading" className="CourseTitle" data-aos="fade-up">
						<h1>{MCAData.course_fullname}</h1>
					</div>
					<br />
					<p className="CourseDesc" data-aos="fade-up">
						{MCAData.course_desc}
					</p>
					<br />

					<div className="CourseDetailsContainer">
						<div id="Secondary_Heading" data-aos="fade-up">
							<h3>Course Detail</h3>
						</div>
						<div className="CourseTable" data-aos="fade-up">
							<table>
								<tr data-aos="fade-up">
									<td>Course -</td>
									<td>{MCAData.course_fullname}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Certificate -</td>
									<td>{MCAData.course_certification}</td>
								</tr>

								<tr data-aos="fade-up">
									<td>Duration -</td>
									<td>{MCAData.course_duration}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>No of Semester -</td>
									<td>{MCAData.course_sem}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Seats -</td>
									<td>{MCAData.course_seat}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Eligibility -</td>
									<td>{MCAData.course_eligibility}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>Fees -</td>
									<td>{MCAData.course_fee_per_sem}</td>
								</tr>
								<tr data-aos="fade-up">
									<td>University -</td>
									<td>{MCAData.university}</td>
								</tr>
							</table>
						</div>
					</div>

					<div className="CourseDetailsProcess" data-aos="fade-up">
						{/* 3. ELIGIBILITY FOR ADMISSION AND PATTERN OF SELECTION */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>
									3. ELIGIBILITY FOR ADMISSION AND PATTERN OF SELECTION
								</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) Master degree with Bachelor of Education Degree
										(B.Ed.) holder of Vinoba Bhave University or any other
										recognized University of India having obtained at least
										45% marks.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) The Selection of candidates for admission to M.Ed.
										Course shall be made on the basis of marks obtained in
										Bachelor degree course, Master degree course and B.Ed.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(c) The admission shall be made strictly in order of
										merit.
									</div>
								</li>
							</ul>
						</div>

						{/* 4. AVAILABILITY OF SEATS */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>4. AVAILABILITY OF SEATS :</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) The total no. of students to be admitted to the M.Ed.
										Course shall be fixed by the Vinoba Bhave University in
										accordance with norms of the National Council for Teacher
										Education (NCTE) from time to time.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) The admission will be open to all students of
										Jharkhand State and the nation over.
									</div>
								</li>
							</ul>
						</div>

						{/* 5. RESERVATION */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>5. RESERVATION :</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) As per Government of Jharkhand Rules declared from
										time to time and adopted by the University.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) Seats left unfilled in any of the reserved category
										by reason of the fact that no eligible candidate is
										available in the respective category shall be filled up
										by admitting candidates available from other reserved
										categories keeping the hierarchy of reserved/unreserved
										into consideration.
									</div>
								</li>
							</ul>
						</div>

						{/* 6. DISQUALIFICATION */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4>6. DISQUALIFICATION :</h4>
							</div>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(a) No candidate shall be permitted to be registered as a
										student in any other course leading to diploma or Degree
										during the Academic Year of his/her study for the M.Ed.
										Course.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(b) No applicant shall be admitted who does not get
										himself/herself enrolled within the specified time.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(c) If its is found that the candidate has furnished any
										false information, his/her candidature shall be
										cancelled immediately.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										(d) The decision of the University regarding admission
										would be final.
									</div>
								</li>
							</ul>
						</div>

						{/* COURSE STRUCTURE */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4 style={{ color: "blue" }}>COURSE STRUCTURE :</h4>
							</div>
							<p style={{ marginBottom: "20px" }}>
								In M.Ed. course the 1<sup>st</sup>, 2<sup>nd</sup>, 3
								<sup>rd</sup> papers shall be compulsory and 4<sup>th</sup> & 5
								<sup>th</sup> papers shall be optional. 6<sup>th</sup> paper
								shall be dissertation with Viva-Voce will compulsory.
							</p>
							<p style={{ marginBottom: "10px", fontWeight: "bold" }}>
								All papers are to be completed as under :
							</p>
							<div className="CourseTable">
								<table>
									<thead>
										<tr>
											<th>Papers</th>
											<th>Course of study</th>
											<th>Internal Marks</th>
											<th>External Marks</th>
											<th>Practical Marks</th>
											<th>Full Marks</th>
											<th>Pass Marks</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>I</td>
											<td>
												Philosophical and Sociological Foundation of Education
												(Comp.)
											</td>
											<td>20</td>
											<td>80</td>
											<td>NIL</td>
											<td>100</td>
											<td>33</td>
										</tr>
										<tr>
											<td>II</td>
											<td>
												Psychological Foundation of Education (Compulsory)
											</td>
											<td>NIL</td>
											<td>80</td>
											<td>20</td>
											<td>100</td>
											<td>33</td>
										</tr>
										<tr>
											<td>III</td>
											<td>
												Methodology of Educational Research (Compulsory)
											</td>
											<td>20</td>
											<td>80</td>
											<td>NIL</td>
											<td>100</td>
											<td>33</td>
										</tr>
										<tr>
											<td>IV & V</td>
											<td>
												<b>Optional Paper</b>
												<br />
												a) Teacher Education
												<br />
												b) Educational Administration & Management
												<br />
												c) Guidance & Counselling
												<br />
												d) Educational Technology
												<br />
												e) Educational Measurement & Evaluation
												<br />
												f) Environmental Education
												<br />
												g) Value Education and Human Right
												<br />
												h) Yoga Education
												<br />
												i) Comparative Education
											</td>
											<td>
												20
												<br />
												20
												<br />
												20
												<br />
												20
												<br />
												20
												<br />
												20
												<br />
												20
												<br />
												20
												<br />
												20
											</td>
											<td>
												80
												<br />
												80
												<br />
												80
												<br />
												80
												<br />
												80
												<br />
												80
												<br />
												80
												<br />
												80
												<br />
												80
											</td>
											<td>
												NIL
												<br />
												NIL
												<br />
												NIL
												<br />
												NIL
												<br />
												NIL
												<br />
												NIL
												<br />
												NIL
												<br />
												NIL
												<br />
												NIL
											</td>
											<td>
												100
												<br />
												100
												<br />
												100
												<br />
												100
												<br />
												100
												<br />
												100
												<br />
												100
												<br />
												100
												<br />
												100
											</td>
											<td>
												33
												<br />
												33
												<br />
												33
												<br />
												33
												<br />
												33
												<br />
												33
												<br />
												33
												<br />
												33
												<br />
												33
											</td>
										</tr>
										<tr>
											<td>VI</td>
											<td>
												Dissertation and Viva-Voce (Compulsory)
											</td>
											<td>40</td>
											<td>60</td>
											<td>NIL</td>
											<td>100</td>
											<td>40</td>
										</tr>
									</tbody>
									<tfoot>
										<tr>
											<td>Total</td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td>600</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							</div>
							<br />
							<div className="SubHeading">
								<h4 style={{ color: "#d32f2f" }}>
									Bases of Internal Assessment :
								</h4>
							</div>
							<p>
								Seminar, Workshop, Symposia, Brain Storming, Assignments,
								Field-activities, Excurtion and House test.
							</p>
						</div>

						{/* HOW TO APPLY */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4 style={{ color: "#007bff" }}>How to Apply</h4>
							</div>
							<p>
								Application form can be obtained from the office of the
								University Department of Education, Vinoba Bhave University
								Campus, Hazaribag. It is to be duly filled in by the candidate
								and submitted to the above office along with all relevant
								documents such as :-
							</p>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										1. Attested Photocopy of the Matriculation / ICSE / CBSE
										pass certificate, showing the candidate's date of birth.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										2. Attested Photocopy of mark sheet of I.A./I.Sc./I.Com.
										examination.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										3. Attested Photocopy of marks sheet of Bachelor Degree,
										Master Degree and B.Ed.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										4. Recent Colour stamp size photograph.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										5. Attested Photocopy of caste certificate issued by the
										authority not below the rank of SDO.
									</div>
								</li>
							</ul>
							<br />
							<p>
								Application forms should be submitted to the office of the
								Department. Incomplete and late application form or furnishing
								false information will be summarily rejected without any
								information to the concerned candidate. In this connection no
								correspondence will be entertained.
							</p>
						</div>

						{/* SELECTION OF CANDIDATES FOR ADMISSION */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4 style={{ color: "#007bff" }}>
									Selection of Candidates for Admission
								</h4>
							</div>
							<p>
								The selection of candidates for admission to M.Ed. course will
								be done strictly in accordance with the merit list prepared on
								the basis of rules and regulations laid down by the Govt. of
								Jharkhand and Vinoba Bhave University, Hazaribag. List of the
								selected candidates will be displayed on the office notice
								board, and the candidate selected for admission will be
								informed by registered post. They will be required to get
								admitted within the stipulated time, failing which the seat
								will be offered to the next candidate in the waiting list.
							</p>
						</div>

						{/* SELECTION PROCEDURE */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4 style={{ color: "#007bff" }}>Selection Procedure</h4>
							</div>
							<p>
								Admission in above course shall be on the basis of your
								obtained career points which is fixed by the university
								authority.
							</p>
						</div>

						{/* ADMISSION LIST */}
						<div
							className="Section"
							style={{ marginBottom: "30px" }}
							data-aos="fade-up"
						>
							<div className="SubHeading">
								<h4 style={{ color: "#d32f2f" }}>Admission :</h4>
							</div>
							<p>
								The following original certificates must be produced by the
								candidates at the time of admission/ counseling :-
							</p>
							<ul>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										1. College leaving certificate
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										2. Registration number of Vinoba Bhave University, if any;
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										3. In case the candidate has passed his/her last
										examination from a University other than Vinoba Bhave
										University, Migration certificate of the university from
										which the candidate received his/her B.Ed. or Masters
										Degree.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										4. Caste Certificate (for SC/ST/BC/OBC only) issued by an
										authority not below the rank of SDO.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										5. Three copies of recent stamp size photograph (same as
										pasted in the application form)
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										6. Mark sheet from matriculation upto the last acquired
										degree.
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										7. Matriculation Certificate
									</div>
								</li>
								<li
									style={{
										display: "flex",
										gap: "10px",
										alignItems: "flex-start",
										lineHeight: "1.6",
										marginBottom: "10px",
									}}
								>
									<div style={{ minWidth: "15px", marginTop: "5px" }}>
										<BsLightningFill className="check-icon" />
									</div>
									<div style={{ flex: 1 }}>
										8. Physically Challenged Certificate, if any;
									</div>
								</li>
							</ul>
						</div>
					</div>



					<section>
						<Courses />
					</section>
				</div>
			</div>
		</>
	);
}

export default MEd;
